<template>
  <div :class="$style.root">
    <h1 :class="$style.title" data-testid="overlay-message-title">
      {{ title }}
    </h1>

    <slot />

    <button
      v-if="actionLabel"
      type="button"
      :class="[$style.action, 'kiosk-button']"
      data-testid="overlay-message-action"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  actionLabel?: string;
}

withDefaults(defineProps<Props>(), {
  actionLabel: undefined,
});

const emit = defineEmits<{
  action: [];
}>();
</script>

<style module>
.root {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 60rem;
  padding:
    var(--Kiosk--wrapper-top-gap)
    var(--Kiosk--wrapper-side-gap)
    var(--Kiosk--wrapper-bottom-gap)
    var(--Kiosk--wrapper-side-gap);
  margin: 0 auto;
}

.title {
  white-space: var(--kiosk-overlay-message-title-white-space);
}

.action {
  margin-top: 2rem;
}
</style>
